import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddPlusFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.0004 3.3999C11.389 3.3999 10.9004 3.88853 10.9004 4.4999V10.8999H4.50039C3.88902 10.8999 3.40039 11.3885 3.40039 11.9999C3.40039 12.6113 3.88902 13.0999 4.50039 13.0999H10.9004V19.4999C10.9004 20.1113 11.389 20.5999 12.0004 20.5999C12.6118 20.5999 13.1004 20.1113 13.1004 19.4999V13.0999H19.5004C20.1118 13.0999 20.6004 12.6113 20.6004 11.9999C20.6004 11.3885 20.1118 10.8999 19.5004 10.8999H13.1004V4.4999C13.1004 3.88853 12.6118 3.3999 12.0004 3.3999Z",
		fill: "currentColor"
	})
});
export default SvgAddPlusFill;
